import React, {Component} from 'react';

let i18n = require("i18next");
import classNames from 'classnames';
import moment from "moment";

class DropDownItem extends Component {
    render() {
        return (
            <li className={classNames("dropdownli", this.props.liClass)} style={this.props.style}>
                <a tabIndex="-1" className={this.props.aClass} href={this.props.href}>
                    {this.props.children}
                </a>
            </li>
        )
    }
}

class DropDownMenu extends Component {
    render() {
        const activityStyle = {
            position: "absolute", width: 10, height: 10, zIndex: 1,
            top: 10, left: 10
        };

        let items = [];

        if (this.props.hasActivity) {
            items.push(
                <DropDownItem aClass="activity" href="#" key="activity">
                    <img style={{width: 10, height: 10}} src="/images/navbar/settings_activity.png"/>

                    <div className="never-allow">{i18n.t("pos.activity.menu")}</div>
                </DropDownItem>
            );
        }

        if (this.props.hasMembership && !this.props.user.isWaiter) {
            items.push(
                <DropDownItem liClass="chargeli memberCharge" key="6" href="#">
                    <div className="never-allow">{i18n.t("pos.header.charge")}</div>
                </DropDownItem>
            );
        }
        if (this.props.user.isAdmin) {
            // items.push(
            //     <DropDownItem key="1" liClass="wechatli"
            //                   href={this.props.hasWeixin ? '#settings/restaurant/wechat' : '/pricing'}>
            //         <div className="never-allow">{i18n.t("pos.header.weixin")}</div>
            //     </DropDownItem>
            // );
        }
        return (
            <div className="mainMenu" style={{position: "absolute", right: 0, top: 0, zIndex: 100}}>
                <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                    {this.props.hasActivity ?
                        <img style={activityStyle} src="/images/navbar/settings_activity.png"/> : null}
                    <div className="dropdownImg"></div>
                </a>
                <ul className="dropdown-menu pull-right" role="menu" aria-labelledby="dLabel">
                    {items}
                    <DropDownItem key="1" liClass="wechat"
                                  href={this.props.hasWeixin ? '#settings/restaurant/wechat' : '/pricing'}>
                        <div className="never-allow">{i18n.t("pos.header.weixin")}</div>
                    </DropDownItem>
                    {this.props.restaurant.kitchenSystem ?
                        <DropDownItem liClass="kitchenLi" key="8"
                                      href={"/kitchenSystem/choosePrintTag/" + this.props.restaurant.id}>
                            <div className="never-allow">{i18n.t("pos.header.kitchenSystem")}</div>
                        </DropDownItem> : null}
                    <DropDownItem key="4" href="#settings/settingsNavigator">
                        <div className="never-allow">{i18n.t("pos.header.settings")}</div>
                    </DropDownItem>
                    <DropDownItem liClass="flushLi" key="7" href="#">
                        <div className="never-allow">{i18n.t("pos.header.reload")}</div>
                    </DropDownItem>
                    {!this.props.branded ? <DropDownItem liClass="paymentli pricing" key="3" href="#">
                        <div className="never-allow">{i18n.t("pos.header.license")}</div>
                    </DropDownItem> : null}
                    <DropDownItem key="9" href="/logout">
                        <img src={require("../images/pos/logout.png")} style={{position: "relative", top: -2}}/>

                        <div className="never-allow">{i18n.t("logout")}</div>
                    </DropDownItem>
                    <DropDownItem key="10" href="#" liClass="userli">
                        <div
                            className="never-allow">{this.props.user.fullname ? this.props.user.fullname : this.props.user.name}</div>
                    </DropDownItem>
                    <DropDownItem liClass="leftLi" key="8" href="#">
                        <div className="never-allow">有效期:{this.props.licenseDate}</div>
                    </DropDownItem>
                </ul>
            </div>
        );
    }
}

var mainButtons = {
    cashier: {
        normal: require("../images/navbar/cashier_redisign.png"),
        active: require("../images/navbar/cashier_redisign-active.png")
    },
    order: {
        normal: require("../images/navbar/order_redisign.png"),
        active: require("../images/navbar/order_redisign-active.png")
    },
    overview: {
        normal: require("../images/navbar/overview_redisign.png"),
        active: require("../images/navbar/overview_redisign-active.png")
    },
    sales: {
        normal: require("../images/navbar/sales_redisign.png"),
        active: require("../images/navbar/sales_redisign-active.png")
    }
}

export default class Header extends Component {
    mainButton(name, isActive, width, height, title) {
        const url = mainButtons[name].normal;
        const activeUrl = mainButtons[name].active;
        return (
            <a key={name} href={"#" + name} data-href={"#" + name}>
                <span className={classNames(name, isActive ? " active" : "")}>
                    <img src={url} width={width} height={height} className="inactive"/>
                    <img src={activeUrl} width={width} height={height} className="active"/>
                    <div className="never-allow">{i18n.t(title)}</div>
                </span>
            </a>
        );
    }

    tip() {
        return (
            <div key="tip" className="tip hidden">
                <span className="tipcontent"></span>

                <div className="arrow"></div>
            </div>
        );
    }

    baseFeatures() {
        return (
            <div className="nav navbar-nav mainMenu" style={{marginTop: 0}}>
                {!this.props.restaurant.fastFood ? this.mainButton('overview', true, 17, 19, "pos.header.overview") : null}
                {this.mainButton('order', false, 18, 19, "pos.header.order")}
                {this.mainButton('cashier', false, 13, 19, "pos.header.cashier")}
                {this.mainButton('sales', false, 20, 16, "pos.header.stats")}
                {this.tip()}
            </div>
        );
    }

    noValidLicense() {
        return (
            <div className="nav navbar-nav" style={{marginTop: 0}}>
                {this.props.isExpRest ? this.expRestaurantHint() : null}
                {this.tip()}
            </div>
        );
    }

    expRestaurantHint() {
        return (
            <div className="experienceRestaurantHint hidden">
                <img src={require("../images/pos/survey2.png")}/>
            </div>
        );
    }

    notificationIcon() {
        return (
            <span key="notification" id="notification-status" className="notification-status">
                    <div className="notification-icon">
                        <img src={require("../images/pos/notification.png")}/>
                        <span className="badge"
                              style={{display: this.props.unreadMessage > 0 ? "block" : "none"}}>{this.props.unreadMessage}</span>
                    </div>
                    <div style={{position: "relative"}} className="hidden notification-details">
                        <img src={require("../images/pos/point-noti.png")}
                             style={{position: "absolute", marginTop: "6px"}}
                        />

                        <div className="notification-center">
                            <div className="header">消息中心</div>
                            <div className="body">
                                <ul className="notification-ul">
                                </ul>
                            </div>
                            <div className="footer">
                                <img src={require("../images/pos/more.png")} style={{margin: "0 5px 4px 0"}}/>
                                <a href="#notifications">查看更多</a>
                            </div>
                        </div>
                    </div>
                </span>
        );
    }

    printIcon() {
        return (
            <span key="print" id="print-status" className="print-status" data-placement="bottom">
                <img src={require("../images/pos/printError.png")}
                     className="printer-status-icon printer-error hidden"/>
                <img src={require("../images/pos/printOnline.png")} className="printer-status-icon printer-open hidden"
                     title={i18n.t("pos.printer.open")}/>
                <img src={require("../images/pos/printOffline.png")} className="printer-status-icon printer-close"
                     title={i18n.t("pos.printer.close")}/>
                <span className="counter"></span>
                    </span>
        );

    }

    functionButtons() {
        return this.props.hasBaseFeature ? [
            <span key="2" className="help-icon"></span>,
            <span key="3" className="network-icon online" data-placement="bottom"></span>,
            this.props.printable ? this.printIcon() : null,
            this.notificationIcon(),
            <span key="4" className="sync-icon online"></span>
        ] : [];
    }

    dateTime() {
        let printStatus;

        if (this.props.printable) {
            printStatus = <span className="print-status">
                <img src={require("../images/pos/printOnline.png")} className="printer-open hidden"
                     title={i18n.t('pos.printer.open')}/>
                <img src={require("../images/pos/printOffline.png")} className="printer-close"
                     title={i18n.t('pos.printer.close')}/>
                </span>
        }

        return (
            <span className="dateTime pull-right hidden" style={{marginRight: "70px"}}>
                <div>
                <span className="username">
                {this.props.user.fullname ? this.props.user.fullname : this.props.user.name}
                </span>
                <span className="offline hidden">
                {i18n.t("webpos.offline")}
                </span>
                </div>
                <span>
                {printStatus}
                    <span className="time">{new moment().format("HH:mm")}</span>
                <span className="date">{new moment().format("yyyy/M/dd")}</span>
                </span>
                </span>
        );
    }

    render() {
        console.log('header ', this.props);
        const publicityBoardStyle = {marginRight: 5, cursor: "pointer"};
        let reserveTime = this.props.showConsultNotContact ?
            <img className="consultReserveTime pull-right hidden" style={publicityBoardStyle}
                 src="/images/pos/consult-reserve-time.png"/> : null;
        let survey = this.props.hasSurveyActivity && !this.props.restaurant.isExpRest ?
            <img className="surveyActivity pull-right hidden" style={publicityBoardStyle}
                 src={require("../images/pos/survey-activity.png")}/> : null;
        return (
            <nav className="navbar navbar-default " role="navigation">
                <div className="navbar-header">
                    <a className="navbar-brand" href="#"><img src={require('../images/pos/poslogo_blue.png')} width="26"
                                                              height="27"/></a>
                </div>
                <div className="collapse navbar-collapse" style={{display: "block"}}>
                    {this.props.hasBaseFeature ? this.baseFeatures() : this.noValidLicense()}
                    <span className="functionButtons">{this.functionButtons()}</span>
                    <DropDownMenu {...this.props} />
                </div>

                <div id="needRefresh" className="refresh alert alert-danger alert-dismissable hidden">
                    <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                    <div className="never-allow">{i18n.t("pos.setting.settingSaved")}</div>
                    <a href="#" className="alert-link" onClick={() => false}>
                        <div className="never-allow">{i18n.t("pos.setting.needRefresh")}</div>
                    </a>
                </div>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/react/Header.react.js